<div class="wrapper">
  <div class="container px-0">
    <h5 class="main-title">{{practice_name}}</h5>
    <div class="main-info">
      {{ 'madisonregistration.formInfo' | translate }}
    </div>
    <div class="px-3 pb-3">
      <form [formGroup]="registrationForm">
        <div class="form-row">

          <div class="col-md-4">
            <div class="form-group ">
              <div class="input-icon form-floating">
                <input type="text" class="form-control" placeholder="{{ 'madisonregistration.firstNamePlaceholder' | translate }}" formControlName="firstname" [ngStyle]="{'border' : getregistrationForm.firstname.invalid && getregistrationForm.firstname.touched && getregistrationForm.firstname.errors!.required ? '1px solid red' : ''}"
                       maxlength="35" (input)="ValidatePersonalInfo($event,'firstname')" />
                <label [ngClass]="getregistrationForm.firstname.invalid && getregistrationForm.firstname.touched && getregistrationForm.firstname.errors!.required ? 'text-danger' : ''">
                  {{ 'madisonregistration.firstNameLabel' | translate }} <span class="text-danger">*</span>
                </label>
              </div>
              <span *ngIf="getregistrationForm.firstname.invalid && getregistrationForm.firstname.touched && getregistrationForm.firstname.errors!.required" class="err">
                {{ 'madisonregistration.firstNameError' | translate }}
              </span>
            </div>

          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="input-icon form-floating">
                <input type="text" class="form-control" placeholder="{{ 'madisonregistration.lastNamePlaceholder' | translate }}" formControlName="lastname" [ngStyle]="{'border' : getregistrationForm.lastname.invalid && getregistrationForm.lastname.touched && getregistrationForm.lastname.errors!.required ? '1px solid red' : ''}"
                       maxlength="35" (input)="ValidatePersonalInfo($event,'lastname')" />
                <label [ngClass]="getregistrationForm.lastname.invalid && getregistrationForm.lastname.touched && getregistrationForm.lastname.errors!.required ? 'text-danger' : ''">
                  {{ 'madisonregistration.lastNameLabel' | translate }} <span class="text-danger">*</span>
                </label>
              </div>
              <span *ngIf="getregistrationForm.lastname.invalid && getregistrationForm.lastname.touched && getregistrationForm.lastname.errors!.required" class="err">
                {{ 'madisonregistration.lastNameError' | translate }}
              </span>
            </div>
          </div>
          <div class="col-md-4 col-xs-6">
            <div class="form-group">
              <div class="position-relative form-floating">
                <input type="date" class="form-control" value="4/23/1998" placeholder="{{ 'madisonregistration.dobPlaceholder' | translate }}" formControlName="dob" [ngStyle]="{'border' : getregistrationForm.dob.invalid && getregistrationForm.dob.touched && (getregistrationForm.dob.errors!.maxDate || getregistrationForm.dob.errors!.required) ? '1px solid red' : ''}"
                       (focusout)="focusOutFunction($event, 0)" max="{{curDate | date:'yyyy-MM-dd'}}" />
                <label [ngClass]="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && (getregistrationForm.dob.errors!.maxDate || getregistrationForm.dob.errors!.required) ? 'text-danger' : ''">
                  {{ 'madisonregistration.dobLabel' | translate }} <span class="text-danger">*</span>
                </label>
              </div>
              <span *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.required" class="err">
                {{ 'madisonregistration.dobError' | translate }}
              </span>
              <span class="err" *ngIf="getregistrationForm.dob.invalid && getregistrationForm.dob.touched && getregistrationForm.dob.errors!.maxDate">{{ 'madisonregistration.dobInvalidError' | translate }}</span>
            </div>
          </div>
          <div class="col-md-4 col-xs-6">
            <div class="form-group">
              <div class="form-select form-floating">
                <select class="form-control" formControlName="gender" (change)="onFocusOutLocation($event.target,'gender')">
                  <option value="" disabled selected>{{ 'madisonregistration.genderSelectPrompt' | translate }}</option>
                  <option value="Male">{{ 'madisonregistration.genderOptionMale' | translate }}</option>
                  <option value="Female">{{ 'madisonregistration.genderOptionFemale' | translate }}</option>
                  <option value="UNK">{{ 'madisonregistration.genderOptionUnknown' | translate }}</option>
                </select>
                <label>{{ 'madisonregistration.genderSelectPrompt' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <div class="form-select form-floating">
                <select class="form-control" formControlName="maritalstatus" (change)="onFocusOutLocation($event.target,'maritalstatus')">
                  <option value="" disabled selected>{{ 'madisonregistration.maritalStatusSelectPrompt' | translate }}</option>
                  <option value="Single">{{ 'madisonregistration.maritalStatusOptionSingle' | translate }}</option>
                  <option value="Married">{{ 'madisonregistration.maritalStatusOptionMarried' | translate }}</option>
                  <option value="Widowed">{{ 'madisonregistration.maritalStatusOptionWidowed' | translate }}</option>
                  <option value="Widower">{{ 'madisonregistration.maritalStatusOptionWidower' | translate }}</option>
                  <option value="Separated">{{ 'madisonregistration.maritalStatusOptionSeparated' | translate }}</option>
                  <option value="Divorced">{{ 'madisonregistration.maritalStatusOptionDivorced' | translate }}</option>
                  <option value="Partner">{{ 'madisonregistration.maritalStatusOptionPartner' | translate }}</option>
                  <option value="Annulled">{{ 'madisonregistration.maritalStatusOptionAnnulled' | translate }}</option>
                  <option value="Polygamous">{{ 'madisonregistration.maritalStatusOptionPolygamous' | translate }}</option>
                  <option value="Never Married">{{ 'madisonregistration.maritalStatusOptionNeverMarried' | translate }}</option>
                  <option value="Legally Separated">{{ 'madisonregistration.maritalStatusOptionLegallySeparated' | translate }}</option>
                  <option value="Interlocutory">{{ 'madisonregistration.maritalStatusOptionInterlocutory' | translate }}</option>
                  <option value="Domestic partner">{{ 'madisonregistration.maritalStatusOptionDomesticPartner' | translate }}</option>
                  <option value="No Information">{{ 'madisonregistration.maritalStatusOptionNoInformation' | translate }}</option>
                  <option value="Unknown">{{ 'madisonregistration.maritalStatusOptionUnknown' | translate }}</option>
                  <option value="Other">{{ 'madisonregistration.maritalStatusOptionOther' | translate }}</option>
                </select>
                <label>{{ 'madisonregistration.maritalStatusSelectPrompt' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="text" placeholder="{{ 'madisonregistration.addressPlaceholder' | translate }}" class="form-control" formControlName="Address" />
              <label>{{ 'madisonregistration.addressLabel' | translate }}</label>
              <span *ngIf="getregistrationForm.Address.invalid && getregistrationForm.Address.touched && getregistrationForm.Address.errors!.required"
                    class="err">{{ 'madisonregistration.addressError' | translate }}</span>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-xs-6">
            <div class="form-group">
              <div class="form-group form-floating">
                <input type="number" placeholder="{{ 'madisonregistration.zipPlaceholder' | translate }}" class="form-control" formControlName="zip" [ngStyle]="{'border' : getregistrationForm.zip.invalid && getregistrationForm.zip.touched && getregistrationForm.zip.errors!.required ? '1px solid red' : ''}" maxlength="9"
                       (input)="onlyNumberAllow($event)" />
                <label [ngClass]="getregistrationForm.zip.invalid && getregistrationForm.zip.touched && getregistrationForm.zip.errors!.required ? 'text-danger' : ''">{{ 'madisonregistration.zipLabel' | translate }} <span class="text-danger">*</span></label>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-xs-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="{{ 'madisonregistration.statePlaceholder' | translate }}" class="form-control" formControlName="state" />
              <label>{{ 'madisonregistration.stateLabel' | translate }}</label>
            </div>
          </div>

          <div class="col-md-4 col-xs-6">
            <div class="form-group form-floating">
              <input type="text" placeholder="{{ 'madisonregistration.cityPlaceholder' | translate }}" class="form-control" formControlName="city" />
              <label>{{ 'madisonregistration.cityLabel' | translate }}</label>
            </div>
          </div>




          <div class="col-md-4 col-lg-4 col-xs-6">
            <div class="form-group">
              <div class="form-group form-floating">
                <input type="text" placeholder="{{ 'madisonregistration.cellPhonePlaceholder' | translate }}" class="form-control"
                       formControlName="cell"
                       [ngStyle]="{'border' : getregistrationForm.cell.invalid && getregistrationForm.cell.touched && getregistrationForm.cell.errors!.required ? '1px solid red' : ''}"
                       (input)="validatePhoneNo($event.target);validatePhone($any($event.target).value ,'phone')"
                       maxlength="14" />
                <label [ngClass]="getregistrationForm.cell.invalid && getregistrationForm.cell.touched && getregistrationForm.cell.errors!.required ? 'text-danger' : ''">
                  {{ 'madisonregistration.cellPhoneLabel' | translate }} <span class="text-danger">*</span>
                </label>
                <span *ngIf="getregistrationForm.cell.invalid && getregistrationForm.cell.touched && getregistrationForm.cell.errors!.required" class="err">
                  {{ 'madisonregistration.cellPhoneError' | translate }}
                </span>
              </div>
              <span *ngIf="isNotValidPhone" class="err">{{ 'madisonregistration.invalidPhoneError' | translate }}</span>

            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="email" placeholder="{{ 'madisonregistration.emailAddressPlaceholder' | translate }}"
                     class="form-control" formControlName="email" [ngStyle]="{'border' : !isValidEmail ? '1px solid red' : ''}"
                     (input)="validateEmailAddress($event.target)" />
              <label [ngClass]="!isValidEmail ? 'text-danger' : ''">{{ 'madisonregistration.emailAddressLabel' | translate }} <span class="text-danger">*</span></label>
              <span *ngIf="!isValidEmail" class="err">{{ 'madisonregistration.invalidEmailError' | translate }}</span>
              <span *ngIf="getregistrationForm.email.invalid && getregistrationForm.email.touched && getregistrationForm.email.errors!.required" class="err">
                {{ 'madisonregistration.emailRequiredError' | translate }}
              </span>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="text" placeholder="{{ 'madisonregistration.employerPlaceholder' | translate }}" class="form-control" formControlName="employer" />
              <label>{{ 'madisonregistration.employerLabel' | translate }}</label>
            </div>
          </div>

          <div class="col-md-4">
            <div class="form-group form-floating">
              <input type="text" placeholder="{{ 'madisonregistration.occupationPlaceholder' | translate }}" class="form-control" formControlName="occupation" />
              <label>{{ 'madisonregistration.occupationLabel' | translate }}</label>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<footer class="p-3">
  <div class="container p-0">
    <div class="text-right">
      <a class="btn btn-primary" type="button" (click)="RegistorPatient()">{{ 'madisonregistration.nextButton' | translate }}</a>
    </div>
  </div>
</footer>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="isNotValid_link">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger">{{ 'madisonregistration.invalidLinkTitle' | translate }}</h5>
        <p class="mb-3">{{ 'madisonregistration.invalidLinkMessage' | translate }}</p>
      </div>
    </div>
  </div>
</div>
